import { Component } from '@angular/core';

@Component({
  selector: 'app-collectables',
  imports: [],
  templateUrl: './collectables.component.html',
  styleUrl: './collectables.component.scss'
})
export class CollectablesComponent {

}
